module.exports = __webpack_public_path__ + "img/Billedbog_Litteraere_tekster_for_barn3.8b5fffe8.jpg";